import ReactQuill from "react-quill";
import React, { useEffect, useRef, useState } from "react";

interface EmailBodyEditorProps {
    value: string;
    HandleOnChange: (value: string) => void;
    flagDisable: boolean;
    setFlagBodyValid :React.Dispatch<React.SetStateAction<boolean>>;
}

const EmailBodyEditor: React.FC<EmailBodyEditorProps> = (props) => {
    const {
        value,
        HandleOnChange,
        flagDisable,
        setFlagBodyValid
    } = props;

    const quillRef = useRef<ReactQuill>(null);

    useEffect(() => {
        if (quillRef.current) {
            const editor = quillRef.current.getEditor();
            editor.focus();

            // Move cursor to the end
            const length = editor.getLength();
            editor.setSelection(length, length);
        }
    }, []);

   useEffect(() => {
        if (!quillRef.current) return;

        const editor = quillRef.current.getEditor();
        const plainText = editor.getText().trim();
        setFlagBodyValid(plainText.length > 0);

}, [value]);


    return (
        <React.Fragment>
            <ReactQuill
                ref={quillRef}
                value={value}
                onChange={HandleOnChange}
                modules={{ toolbar: false }} // Removes the toolbar
                className={"emailBodyEditor"}
                readOnly={flagDisable}
            />

        </React.Fragment>
    );
};

export default EmailBodyEditor;
